import { type Dispatch, type SetStateAction, useEffect, useState } from 'react';
import { CheckboxField, SelectField } from '../../../../components/molecules';
import { type UserSignupType } from '../../../../types/UserSignup';

import styles from './ChoiceCategories.module.scss';
import { clientCookie } from '@/utils/clientCookie';

interface IChoiceCategoriesProps {
  updateUserData: Dispatch<SetStateAction<UserSignupType>>;
  userData: UserSignupType;
}

export const ChoiceCategories = ({
  updateUserData,
  userData,
}: IChoiceCategoriesProps) => {
  const [showSubCategories, setShowSubCategories] = useState(false);
  const [subCategoriesGroups, setSubCategoriesGroups] = useState([]);
  const [categories, setCategories] = useState([]);

  function parsedCategories(allCategories) {
    return allCategories.map(({ title, message, sub_category }) => {
      return {
        title,
        message,
        sub_categories_groups: sub_category.sub_categories_groups,
      };
    });
  }

  function handleSelectSubCategory(title, categoriesGroups) {
    clientCookie.set('selectedCategory', title, 1);
    triggerTracking(title);
    setShowSubCategories(true);
    setSubCategoriesGroups(categoriesGroups);
  }

  function renderSelectField() {
    return categories.map(
      ({ title, message, sub_categories_groups }, index) => {
        return (
          <SelectField
            key={index}
            title={title}
            description={message}
            handleClickCard={() =>
              handleSelectSubCategory(title, sub_categories_groups)
            }
          />
        );
      }
    );
  }

  function handleSelectedSubCategoryIds(checkboxValue: string) {
    const checkboxValuesList = checkboxValue.split(',');

    updateUserData((oldState) => {
      const { subCategoryIds } = oldState;
      let newSubCategoryIds = [...subCategoryIds];

      checkboxValuesList.forEach((id) => {
        if (!subCategoryIds.includes(id)) {
          // Add values in the state
          newSubCategoryIds.push(id);
        } else {
          // Remove values of state
          newSubCategoryIds = newSubCategoryIds.filter((oldId) => oldId !== id);
        }
      });

      return {
        ...oldState,
        subCategoryIds: newSubCategoryIds,
      };
    });
  }

  function renderCheckboxFields() {
    return subCategoriesGroups.map(
      ({ title, message, sub_category_ids }, index) => {
        return (
          <CheckboxField
            key={index}
            title={title}
            message={message}
            subCategoryIds={sub_category_ids}
            handleInputClick={handleSelectedSubCategoryIds}
          />
        );
      }
    );
  }

  function triggerTracking(rootValue: string) {
    window.tagManager.custom({
      event: 'selfDescribingEvent',
      schema: 'iglu:br.com.getninjas/pro_sign_up/jsonschema/1-0-1',
      data: {
        step: 'insert_root',
        action: rootValue,
        country: 'pt-BR',
        token: userData.token,
      },
    });
  }

  useEffect(() => {
    updateUserData((oldState) => ({
      ...oldState,
      subCategoryIds: [],
    }));
  }, []);

  useEffect(() => {
    fetch(`${process.env.NEXT_PUBLIC_API_PRO}/categories`)
      .then(async (response) => response.json())
      .then((data) => {
        setCategories(parsedCategories(data.categories));
      });
  }, []);

  return (
    <div className={`choice-categories ${styles['choice-categories']}`}>
      {!showSubCategories ? renderSelectField() : renderCheckboxFields()}
    </div>
  );
};
